import '@f-fertighaus/layout/PageHeader/SSR/PageHeaderSSR'
import '@f/components/PageSharing'
import '@js/common/site-wide'

import React from 'react'

import Modal from '@f/components/Modal'
import CookieModal from '@f/widgets/CookieModal'

void (() => {
  const cookieBannerDisabled = window.SherlockContainer.environment.FEATURE_FLAGS.includes(
    '@FF_DISABLE_COOKIE_BANNER'
  )
  const cookieLinkTrigger = document.querySelector('[href^="#cookie-config"]')

  if (cookieLinkTrigger && !cookieBannerDisabled) {
    cookieLinkTrigger.addEventListener('click', event => {
      const modal = new Modal()
      modal.openModal({
        component: <CookieModal />
      })

      event.preventDefault()
    })
  }
})()
